import { render, staticRenderFns } from "./BulkReviewsTable.vue?vue&type=template&id=20d9914e&scoped=true"
import script from "./BulkReviewsTable.vue?vue&type=script&lang=js"
export * from "./BulkReviewsTable.vue?vue&type=script&lang=js"
import style0 from "./BulkReviewsTable.vue?vue&type=style&index=0&id=20d9914e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20d9914e",
  null
  
)

export default component.exports